import React from "react";
import { useAuthStore } from "@/stores/auth/store";
import { Navigate, Outlet } from "react-router-dom";

/**
 * ProtectedRoute: Only renders children if authenticated, otherwise redirects to /login.
 * Usage: <Route element={<ProtectedRoute />}><Route ... /></Route>
 */
const ProtectedRoute: React.FC = () => {
  const {user} = useAuthStore();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
